import {useInfiniteQuery} from 'react-query';
import useInfiniteScroll from '../../../../../utilities/hooks/useInfiniteScroll';
import {getCashBackHistoryList} from './getCashBackHistoryList';

const useGetCashBackHistoryList = (cashBackGuid?: string) => {
  const {
    data: rawData,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useInfiniteQuery(
    ['get-cash-back-history', cashBackGuid],
    ({pageParam = 1}) =>
      getCashBackHistoryList({
        pageParam,
        cashBackGuid: cashBackGuid!,
      }),
    {
      enabled: Boolean(cashBackGuid),
      getNextPageParam: (lastPage, allPages) =>
        lastPage.next ? allPages.length + 1 : undefined,
    },
  );

  const data = rawData?.pages.flatMap(page => page.results) ?? [];

  const loaderRef = useInfiniteScroll({
    isLoading,
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
  });

  return {
    data,
    isLoading,
    loaderRef,
    isFetchingNextPage,
    hasNextPage,
  };
};

export default useGetCashBackHistoryList;
